import type { DemoKey } from './keys';

export const sw: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Jiometria · 3D',
  'panel.figure': 'Umbo',
  'panel.dims': 'Vipimo',
  'panel.style': 'Mwonekano',
  'panel.lines': 'Mistari maalum',
  'style.body': 'Mwili',
  'style.line': 'Mstari',
  'style.cut': 'Sehemu',
  'style.labels': 'Lebo za vipeo',
  'group.face': 'Mistari ya pembe / mizalisha',
  'group.space': 'Mistari ya pembe / mihimili / wastani',
  'split.label': 'Sehemu',
  'btn.animate': 'Cheza',
  'btn.reset': 'Anza upya',
  'hint.line1': 'Buruta ili kuzungusha · Sogeza ili kukuza',
  'hint.line2': 'Bofya mstari kuchagua',
  'fig.cuboid': 'Mchemraba mstatili',
  'fig.cube': 'Mchemraba',
  'fig.triPrism': 'Mche-pembetatu',
  'fig.hexPrism': 'Mche-pembesita',
  'fig.tetrahedron': 'Tetrahedroni',
  'fig.squarePyramid': 'Piramidi ya mraba',
  'fig.cylinder': 'Mche-mzunguko',
  'fig.cone': 'Koni',
  'fig.sphere': 'Tufe',
  'fig.frustumPyramid': 'Piramidi iliyokatwa',
  'fig.frustumCone': 'Koni iliyokatwa',
  'dim.length': 'urefu',
  'dim.width': 'upana',
  'dim.height': 'kimo',
  'dim.side': 'upande',
  'dim.radius': 'kipenyo nusu',
  'dim.r1': 'kipenyo nusu chini',
  'dim.r2': 'kipenyo nusu juu',
  'dim.sideBase': 'upande wa msingi',
  'dim.sideTop': 'upande wa juu',
  'info.face': 'pande',
  'info.center': 'kupitia katikati',
  'info.diagonal': 'pembe',
  'info.axial': 'pembe ya mhimili',
  'info.diameter': 'kipenyo',
  'info.generator': 'mzalisha',
  'info.axis': 'mhimili',
  'info.height': 'kimo',
  'info.median': 'wastani',
  'info.apothem': 'apotemu',
  'info.diameterBase': 'kipenyo cha msingi',
  'info.diameterTop': 'kipenyo cha juu',
};
